import onChangePhoneNumber from "helpers/onChangePhoneNumberV2";
import ICarret from "assets/i-carret.js";

const FormCustInfo = ({ control, Controller, dial_code, onOpenModalPilihCodeNegara }) => {
  return (
    <div>
      <div className="flex items-center gap-2 py-2">
        <p className="w-[126px] py-2 text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#252526]">
          Nama Customer
          <span className="text-[#FD4949] font-inter-semibold">*</span>
        </p>
        <Controller
          control={control}
          name="name"
          render={({ field }) => (
            <div className="w-[calc(100%-126px)]">
              <input
                type="text"
                {...field}
                className="w-full text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#252526] p-2 rounded-[4px] border-[1px] border-solid border-[#D8D8D9] placeholder:text-[#D8D8D9]"
                placeholder="contoh: John Doe"
              />
              {field.error && (
                <p className="mt-1text-[11px] leading-[17px] tracking-[-0.4px] font-inter text-[#FD4949]">
                  {field.error.message}
                </p>
              )}
            </div>
          )}
        />
      </div>

      <div className="flex items-center gap-2 py-2">
        <p className="w-[126px] py-2 text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#252526]">
          Nomor WhatsApp
          <span className="text-[#FD4949] font-inter-semibold">*</span>
        </p>
        <div className="w-[calc(100%-126px)] flex items-center gap-2">
          <div onClick={onOpenModalPilihCodeNegara} className="flex items-center justify-between gap-2 w-[80px] p-2 rounded-[4px] border-[1px] border-solid border-[#D8D8D9] placeholder:text-[#D8D8D9]">
            <span className="text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#252526]">{dial_code}</span>
            <div className="rotate-90 w-fit h-fit">
              <ICarret />
            </div>
          </div>
          <Controller
            control={control}
            name="whatsapp_number"
            render={({ field }) => (
              <div>
                <input
                  type="text"
                  {...field}
                  onChange={(e) => onChangePhoneNumber(e, field.onChange)}
                  value={field.value}
                  className="w-full text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#252526] p-2 rounded-[4px] border-[1px] border-solid border-[#D8D8D9] placeholder:text-[#D8D8D9]"
                  placeholder="contoh: 085478560909"
                />
                {field.error && (
                  <p className="mt-1 text-[11px] leading-[17px] tracking-[-0.4px] font-inter text-[#FD4949]">
                    {field.error.message}
                  </p>
                )}
              </div>
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default FormCustInfo;
